import { Row, Col, Button } from 'antd';
import moment from 'moment';
import { getWorkspace } from 'pages/LoginPage/thunk';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { ModalWarningLeavePage, Rectangle } from 'components';
import { t_equipment_lease } from 'types';
import { equipmentNewItem, getDataStoreFieldEquipment, getDataStoreFieldMachine } from '../thunk';
import TableInfo from './TableInfo';
import Wrap from './styles';

type Props = {
  nextStep: () => void;
  stepToPrevious: () => void;
  checked: boolean;
};

const MachineRegisterSecondStep: FC<Props> = ({ nextStep, stepToPrevious, checked }) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { equipment, machine } = useSelector((state: RootState) => state.machineequipment);
  const { currentApplicationId } = useSelector((state: RootState) => state.workSpaces);

  const handleSubmit = async () => {
    setLoading(true);
    const newItemEquipment: t_equipment_lease = {
      lease_start_date: equipment.lease_start_date ? equipment.lease_start_date : undefined,
      lease_end_date: equipment.lease_end_date ? equipment.lease_end_date : undefined,
      lease_company: equipment.lease_company?.display_id,
      lease_contract_date: equipment.lease_contract_date,
      lease_shop: equipment.lease_shop?.display_id,
      lease_contract_id: equipment.lease_contract_id,
      machine_quantity: equipment.machine_quantity,
      purchased_equipment: checked ? 1 : undefined,
    };
    const payload = { item: newItemEquipment, return_item_result: true, machine: machine };
    await dispatch(equipmentNewItem(payload));
    setLoading(false);
    nextStep();
  };

  useEffect(() => {
    dispatch(getWorkspace());
  }, [dispatch]);

  useEffect(() => {
    currentApplicationId &&
      dispatch(getDataStoreFieldMachine({ appId: currentApplicationId, dataStoreId: 't_machine' }));
  }, [dispatch, currentApplicationId]);

  useEffect(() => {
    currentApplicationId &&
      dispatch(getDataStoreFieldEquipment({ appId: currentApplicationId, dataStoreId: 't_equipment_lease' }));
  }, [dispatch, currentApplicationId]);

  return (
    <Wrap>
      <span className="smallBoldFont ※">※</span>
      <span className="standardFont">は必須項目</span>
      <Rectangle text="購入機器情報" />
      <div className="info-rental">
        <div className="statistics">
          <Row className="mb-39">
            <Col span={5}>
              <span className="standardBoldFont">リース期間</span>
              {!checked && <span className="smallBoldFont ※">※</span>}
            </Col>
            <Col className="standardFont" span={19}>
              {equipment.lease_start_date && moment(equipment.lease_start_date).format('YYYY年MM月DD日')}
              {equipment.lease_end_date && `〜${moment(equipment.lease_end_date).format('YYYY年MM月DD日')}`}
            </Col>
          </Row>
          <Row className="mb-39">
            <Col span={5}>
              <span className="standardBoldFont">契約日</span>
              <span className="smallBoldFont ※">※</span>
            </Col>
            <Col className="standardFont" span={19}>
              {moment(equipment.lease_contract_date).format('YYYY年MM月DD日')}
            </Col>
          </Row>
          <Row className="mb-39">
            <Col span={5}>
              <span className="standardBoldFont">リース会社</span>
              {!checked && <span className="smallBoldFont ※">※</span>}
            </Col>
            <Col className="standardFont" span={19}>
              {equipment.lease_company?.value}
            </Col>
          </Row>
          <Row className="mb-39">
            <Col span={5}>
              <span className="standardBoldFont">販売店</span>
              <span className="smallBoldFont ※">※</span>
            </Col>
            <Col className="standardFont" span={19}>
              {equipment.lease_shop?.value}
            </Col>
          </Row>
          <Row className="mb-39">
            <Col span={5}>
              <span className="standardBoldFont">契約番号</span>
              <span className="smallBoldFont ※">※</span>
            </Col>
            <Col className="standardFont" span={19}>
              {equipment.lease_contract_id}
            </Col>
          </Row>
        </div>
      </div>
      <div className="detail-table-info">
        <Rectangle text="リース機器一覧" />
        <TableInfo machineData={machine} />
      </div>
      <div className="confirm">
        <p className="standardBoldFont">この内容で登録します。よろしければ「登録する」をクリックしてください。</p>
      </div>
      <div className="confirm-register-btn">
        <Button onClick={stepToPrevious} className="btn-cancel-save">
          戻る
        </Button>
        <Button onClick={handleSubmit} className="btn-save" loading={loading}>
          登録する
        </Button>
      </div>
      <ModalWarningLeavePage />
    </Wrap>
  );
};
export default MachineRegisterSecondStep;
